import { createContext } from 'react'

import { DataSchemaItemFragment } from 'generated/resources/graphql'

import { MappedFields } from 'modules/employees/pages/ImportProcessPage/components/ImportProcessWizard/types'

import { type FilterStatuses } from './components/Filters'
import { type Row } from './editableContentReducer'

type TableContextProviderValue = {
  rowsWithError?: number[]
  enumOptions?: (fieldName: string) => { name: string; id: string }[]
  onCellChange?: (rowIndex: number, columnIndex: number, value: string, isValid: boolean) => void
  onCellClicked?: (rowIndex: number, columnIndex: number) => void
  focusedCell?: { rowIndex: number; columnIndex: number }
  toggleSelectRow?: (rowIndex: number) => void
  mappings?: MappedFields[]
  fields?: DataSchemaItemFragment[]
  rows?: Array<Row | undefined>
  headers?: (string | undefined)[]
  loading?: boolean
  allSelected?: boolean
  handleCheckboxToggle?: () => void
  tableHeadRef?: React.RefObject<HTMLTableSectionElement>
  tableBodyRef?: React.RefObject<HTMLTableSectionElement>
  onClearFilter?: (value: FilterStatuses) => void
}

export const TableContext = createContext<TableContextProviderValue>({})
